import { render, staticRenderFns } from "./StudioPlaylistMediaDetails.vue?vue&type=template&id=0ff5931c&scoped=true&"
import script from "./StudioPlaylistMediaDetails.vue?vue&type=script&lang=js&"
export * from "./StudioPlaylistMediaDetails.vue?vue&type=script&lang=js&"
import style0 from "./StudioPlaylistMediaDetails.vue?vue&type=style&index=0&id=0ff5931c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff5931c",
  null
  
)

export default component.exports